import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { traceability } from '@/mocks/smart-farm';

const fields = [
  { label: '产品批次', value: traceability.product.batch, icon: 'ri-qr-scan-2-line' },
  { label: '采收信息', value: traceability.product.harvest, icon: 'ri-calendar-line' },
  { label: '品质检测', value: traceability.product.test, icon: 'ri-flask-line' },
  { label: '加工包装', value: traceability.product.pack, icon: 'ri-box-3-line' },
  { label: '仓储物流', value: traceability.product.logistic, icon: 'ri-truck-line' },
];

export default function Traceability() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="品质追溯"
          title={traceability.title}
          subtitle={traceability.desc}
        />

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* 左：追溯链路 */}
          <div className="w-full">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {traceability.scanSteps.map((step, idx) => (
                <div
                  key={step.title}
                  className="p-5 rounded-lg bg-background-100 border border-background-200"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 shrink-0">
                      <i className={`${step.icon} text-xl`}></i>
                    </div>
                    <span className="text-xs font-semibold text-accent-600 whitespace-nowrap">
                      {String(idx + 1).padStart(2, '0')}
                    </span>
                  </div>
                  <h3 className="mt-4 font-heading font-bold text-foreground-950 text-base">
                    {step.title}
                  </h3>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-6 flex items-start gap-3 p-5 rounded-lg bg-background-100 border border-accent-200">
              <i className="ri-shield-star-line text-accent-600 text-xl mt-0.5 shrink-0"></i>
              <p className="text-sm text-foreground-800 leading-relaxed">{traceability.note}</p>
            </div>
          </div>

          {/* 右：手机扫码界面模拟 */}
          <Reveal className="w-full">
            <div className="mx-auto max-w-sm">
              <div className="rounded-2xl bg-foreground-950 border border-background-200 p-5">
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">9:41</span>
                  <span className="text-xs text-background-100 font-medium">产品溯源</span>
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-more-2-fill text-background-100"></i>
                  </div>
                </div>

                <div className="mt-5 flex items-start gap-3">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-500 text-foreground-950 shrink-0">
                    <i className="ri-plant-line text-2xl"></i>
                  </div>
                  <div>
                    <div className="font-heading font-bold text-background-50 text-lg">
                      {traceability.product.name}
                    </div>
                    <div className="mt-1 text-xs text-foreground-400">{traceability.product.origin}</div>
                  </div>
                </div>

                <div className="mt-5 flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-full text-xs bg-accent-500/15 text-accent-300 whitespace-nowrap">
                    已建立数字身份
                  </span>
                  <span className="px-2.5 py-1 rounded-full text-xs bg-background-50/10 text-background-100 whitespace-nowrap">
                    一品一标 · 一物一码
                  </span>
                </div>

                <div className="mt-5 space-y-3">
                  {fields.map((field) => (
                    <div
                      key={field.label}
                      className="flex items-center gap-3 p-3 rounded-lg bg-background-50/5 border border-background-50/10"
                    >
                      <i className={`${field.icon} text-accent-400 text-lg shrink-0`}></i>
                      <div className="flex-1 min-w-0">
                        <div className="text-[11px] text-foreground-400">{field.label}</div>
                        <div className="text-sm text-background-100 truncate">{field.value}</div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-5 flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200">
                  <div className="w-16 h-16 flex items-center justify-center rounded-md bg-background-100 text-foreground-950 shrink-0">
                    <i className="ri-qr-code-line text-4xl"></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-950">扫码溯源</div>
                    <div className="mt-1 text-xs text-foreground-500 leading-relaxed">
                      消费者扫码即可查看完整产品档案
                    </div>
                  </div>
                </div>
              </div>
              <p className="mt-3 text-center text-[11px] text-foreground-400">
                界面为产品追溯功能示意，展示信息为脱敏示例
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}